<template>
  <div>
    <transition name="slide-up">
      <div v-if="actionMenu.isOpen" class="drawer" @click.stop>
        <div class="header">
          <i class="fas fa-chevron-down" @click="toggleActionMenu"></i>
        </div>
        <div class="body">
          <div class="grid-container">
            <div class="grid-item" @click="modalDeposit">
              <div>
                <i class="icon fas fa-money-check-alt"></i>
              </div>
              <div>{{ $t('home.depositTitle') }}</div>
            </div>

            <div v-if="isSpinActive" class="grid-item" @click="goToSpin()">
              <div>
                <i class="icon fas fa-crown"></i>
              </div>
              <div>หมุนวงล้อ</div>
              <div class="coin">
                (<i class="fas fa-coins"></i> {{ this.profile.coin }})
              </div>
            </div>
            <div v-else class="grid-item refreshAll" @click="refreshAllSlot">
              <div>
                <i class="icon fas fa-wallet"></i>
              </div>
              <div>{{ $t('home.refreshAllTitle') }}</div>
              <div class="total">
                {{
                  $t('home.allBaht', {
                    total: $options.filters.numberFormat(total)
                  })
                }}
              </div>
              <div class="timesync">({{ timesync | datetimeFormat }})</div>
            </div>

            <div class="grid-item" @click="modalWithdraw()">
              <div>
                <i class="icon fas fa-hand-holding-usd"></i>
              </div>
              <div>{{ $t('home.withdrawTitle') }}</div>
            </div>
            <div class="grid-item" @click="modalCarouselBanner('invite')">
              <div>
                <i class="icon fas fa-user-friends"></i>
              </div>
              <div>{{ $t('home.inviteTitle') }}</div>
            </div>
            <div class="grid-item" @click="goToBonus()">
              <div>
                <i class="icon fas fa-gift"></i>
              </div>
              <div>{{ $t('home.bonusTitle') }}</div>
            </div>
            <div class="grid-item" @click="modalCarouselBanner('refund')">
              <div>
                <i class="icon fas fa-coins"></i>
              </div>
              <div>{{ $t('home.refundTitle') }}</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <modal-deposit
      v-if="modalDepositActive"
      :is-active="modalDepositActive"
      :profile="profile"
      :account="bankAccount"
      @closeModal="modalDeposit"
    />
    <modal-transfer
      v-if="modalTransferActive"
      :is-active="modalTransferActive"
      :wallet="wallet"
      :slots="slots"
      @closeModal="modalTransfer"
    />
    <modal-withdraw
      v-if="modalWithdrawActive"
      :is-active="modalWithdrawActive"
      :wallet="wallet"
      :slots="slots"
      @closeModal="modalWithdraw"
    />
    <modal-invite
      v-if="modalInviteActive"
      :is-active="modalInviteActive"
      :profile="profile"
      @closeModal="modalInvite"
    />
    <modal-refund
      v-if="modalRefundActive"
      :is-active="modalRefundActive"
      :profile="profile"
      @closeModal="modalRefund"
    />
    <modal-carousel-img
      v-if="modalCarouselImgActive"
      :is-active="modalCarouselImgActive"
      :carousel-data="carouselData"
      :act="act"
      @closeModal="closeModalCarouselBanner"
    />
    <div
      v-if="actionMenu.isOpen"
      class="overlay"
      @click="toggleActionMenu"
    ></div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import ModalDeposit from '@/views/user/components/modals/deposit/index'
import ModalTransfer from '@/views/user/components/modals/Transfer'
import ModalWithdraw from '@/views/user/components/modals/Withdraw'
import ModalInvite from '@/views/user/components/modals/Invite'
import ModalRefund from '@/views/user/components/modals/Refund'
import ModalCarouselImg from '@/views/user/components/modals/CarouselImg'

import apiWallet from '@/api/wallet'
import apiInvite from '@/api/invite'
import apiRefund from '@/api/refund'
import apiSpin from '@/api/spin'

export default {
  name: 'ActionMenu',
  components: {
    ModalDeposit,
    ModalTransfer,
    ModalWithdraw,
    ModalInvite,
    ModalRefund,
    ModalCarouselImg
  },
  data() {
    return {
      modalDepositActive: false,
      modalTransferActive: false,
      modalWithdrawActive: false,
      modalInviteActive: false,
      modalRefundActive: false,
      modalCarouselImgActive: false,
      isSpinActive: false,
      carouselData: {},
      act: ''
    }
  },
  computed: {
    ...mapState({
      actionMenu: store => {
        document.documentElement.style.overflow = store.gadget.actionMenu.isOpen
          ? 'hidden'
          : 'auto'
        return store.gadget.actionMenu
      },
      timesync: store => store.userInfo.timesync,
      profile: store => store.userInfo.profile,
      bankAccount: store => store.userInfo.bankAccount,
      wallet: store => store.userInfo.wallet,
      slots: store => store.userInfo.slot,
      slotAccount: store => store.userInfo.slotAccount,
      sportAccount: store => store.userInfo.sportAccount,
      lottoAccount: store => store.userInfo.lottoAccount,
      total: store => store.userInfo.total,
      inviteAmount: store => store.userInfo.inviteAmount,
      inviteSuccess: store => store.userInfo.inviteSuccess,
      inviteFail: store => store.userInfo.inviteFail
    })
  },
  created() {
    this.getUserWallet()
    this.checkSpinActive()
  },
  methods: {
    ...mapActions('gadget', ['toggleActionMenu']),
    ...mapActions('userInfo', ['getUserWallet']),
    async refreshAllSlot() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          await apiWallet.refreshAllSlot()
        } catch (error) {
          console.log(error)
        } finally {
          await this.getUserWallet(true)
          loading.hide()
        }
      }, 200)
    },
    modalDeposit() {
      this.modalDepositActive = !this.modalDepositActive
    },
    modalWithdraw() {
      this.modalWithdrawActive = !this.modalWithdrawActive
    },
    modalRefund() {
      this.modalRefundActive = !this.modalRefundActive
    },
    async modalCarouselBanner(act) {
      this.act = act
      let loading = this.$loading.show()
      if (act === 'invite') {
        const inv = await apiInvite.getInviteBanner()
        loading.hide()
        if (inv.banners.length !== 0) {
          this.carouselData = inv.banners
          this.modalCarouselImgActive = !this.modalCarouselImgActive
        } else {
          this.modalInvite()
        }
      } else if (act === 'refund') {
        const refund = await apiRefund.getRefundBanner()
        loading.hide()
        if (refund.banners.length !== 0) {
          this.carouselData = refund.banners
          this.modalCarouselImgActive = !this.modalCarouselImgActive
        } else {
          this.modalRefund()
        }
      }
    },
    closeModalCarouselBanner(act) {
      this.modalCarouselImgActive = !this.modalCarouselImgActive
      if (act === 'invite') {
        this.modalInvite()
      } else if (act === 'refund') {
        this.modalRefund()
      }
    },
    modalInvite() {
      this.modalInviteActive = !this.modalInviteActive
    },
    goToBonus() {
      this.toggleActionMenu()
      this.$router.push('bonus')
    },
    goToSpin() {
      this.toggleActionMenu()
      this.$router.push('spin')
    },
    async checkSpinActive() {
      const result = await apiSpin.isActive()
      this.isSpinActive = result.isActive
    }
  }
}
</script>

<style scoped lang="scss">
.drawer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 25%;
  widows: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  background: $primary;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 0 30px;
  transform: translateY(0%);
  z-index: 1;
}
.header {
  font-size: xx-large;
  text-align: center;
  margin: auto;

  i {
    color: #ffffff !important;
  }
}
.body {
  max-width: 600px;
  margin: auto;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

/* Transition styles */
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter, .slide-up-leave-to /* .slide-up-leave-active in <2.1.8 */ {
  transform: translateY(100%);
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columns */
  grid-template-rows: repeat(3, 1fr); /* 3 rows */
  gap: 25px; /* Adjust the gap between the grid items if needed */
}

.grid-item {
  cursor: pointer;
  color: $text-color;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  text-align: center;
  height: 15vh;
  max-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .icon {
    color: $text-color; //lighten($color: $light-primary, $amount: 5);
    font-size: xx-large;
  }
}
.total {
  font-size: small;
  font-weight: bold;
}
.timesync {
  font-size: xx-small;
}
</style>
